(function () {
  function isLifetime(variant) {
    if (!variant) return false;

    const title = String(variant.title || "").toLowerCase();
    if (title.includes("lifetime")) return true;

    // option1/2/3 kontrolü (Dawn variant objesinde genelde böyle gelir)
    const o1 = String(variant.option1 || "").toLowerCase();
    const o2 = String(variant.option2 || "").toLowerCase();
    const o3 = String(variant.option3 || "").toLowerCase();
    return [o1, o2, o3].some(v => v.includes("lifetime"));
  }

  function setBadge(sectionId, variant) {
    const badge = document.getElementById(`LifetimeBadge-${sectionId}`);
    if (!badge) return;

    if (isLifetime(variant)) {
      badge.textContent = badge.dataset.lifetimeText || "Best long-term";
      badge.classList.remove("hidden");
    } else {
      badge.classList.add("hidden");
    }
  }

  function getVariants(sectionId) {
    const el = document.getElementById(`ER-Variants-${sectionId}`);
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch { return []; }
  }

  function getSelectedVariant(sectionId) {
    const input =
      document.querySelector(`#product-form-${sectionId} input[name="id"]`) ||
      document.querySelector(`form[id^="product-form-${sectionId}"] input[name="id"]`);

    if (!input) return null;

    const variantId = Number(input.value);
    const variants = getVariants(sectionId);
    return variants.find(v => Number(v.id) === variantId) || null;
  }

  function update(sectionId) {
    setBadge(sectionId, getSelectedVariant(sectionId));
  }

  document.addEventListener("DOMContentLoaded", () => {
    // sayfadaki tüm badge’leri başlat
    document.querySelectorAll('[id^="LifetimeBadge-"]').forEach((badge) => {
      const sectionId = badge.id.replace("LifetimeBadge-", "");
      update(sectionId);

      // variant id input değişimini izle (en sağlam yol)
      const input = document.querySelector(`#product-form-${sectionId} input[name="id"]`);
      if (input) {
        const obs = new MutationObserver(() => update(sectionId));
        obs.observe(input, { attributes: true, attributeFilter: ["value"] });
      }
    });

    // ayrıca picker change yakala (bazı temalarda input value attribute değil property değişiyor)
    document.addEventListener("change", (e) => {
      const picker = e.target.closest("variant-selects, variant-radios");
      if (!picker) return;
      const sectionId = picker.dataset.section || picker.dataset.sectionId;
      if (sectionId) update(sectionId);
    });
  });
})();
